export const LOCALES = {
  ENGLISH: 'en',
  HUNGARY: 'hu',
  GREEK: 'el',
  PORTUGUESE: 'pt',
  SPANISH: 'es',
};
